import {getToken, getUuidMake} from "../Common";
import {optionGrpMapping, optionMapping, shopMapping} from "../service/mappingService";

import axios from "axios";
import * as Common from "../Common";
import {menuStatusFormat} from "./formatService";
import { BACK_OFFICE_API,ORDER_PROXY_API, ORDER_API, POS_API } from "constants/apiUrls";



// 옵션 그룹 조회
export async function getOptionGrpList(shopId) {
  try {
    if(shopId) {
      const response = await axios.get(`${ORDER_API}/menu/v2/option/group?shopId=${shopId}`);
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
}

export async function getOptionGrpList2(shopId) {
  let token = getToken();
  try {
    if(shopId) {
      const response = await axios.get(`${ORDER_API}/menu/option/group/ceo?shopId=${shopId}`, {
        headers: {Authorization: `Bearer ${token}`}
      });
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
}

// 옵션 그룹 상세 조회
export async function getOptionGrpDetail(optionGrpId) {
  try {
    if(optionGrpId) {
      const response = await axios.get(`${BACK_OFFICE_API}/menu/optgrp2?id=${optionGrpId}`);

      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
}

// 하위 옵션 조회
export async function getOptionList(optionGrpId) {
  try {
    if(optionGrpId) {
      const response = await axios.get(`${BACK_OFFICE_API}/menu/option?id=${optionGrpId}`);
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
}

// 옵션 그룹 등록
export function newOptionGrp(shopId, data) {
  let optionGrpId;
  let addOptionList;
  let posShopId;
  let posOptionGrpId;
  let optionList = data.addOptionGroupList[0].optionList;
  let posOptionList = [];

  // 포스 상점ID 조회
  axios.get(`${ORDER_PROXY_API}/shop/v2/pos/shop-code?channelType=2&shopId=${shopId}`).then((response) => {
    posShopId = response.data.shopId;

    // 주문 옵션그룹 등록
    axios.post(`${ORDER_API}/menu/v2/option/group`, data).then((response) => {
      optionGrpId = response.data.addOptionGroupIdList[0].optionGroupId;
      addOptionList = response.data.addOptionGroupIdList[0].optionIdList;

      // 포스 옵션그룹 등록
      axios.post(`${POS_API}/product/v2/option-group`, {
        modifierId: Number(posShopId),
        modifierType: 1,
        shopId: Number(posShopId),
        optionGroupName: String(data.addOptionGroupList[0].name),
        optionDescription: '',
        exposureSequence: data.addOptionGroupList[0].visibleIndex,
        exposureStatus: 1
      }).then((response) => {
        posOptionGrpId = response.data.productOptionGroupId;
        // 포스 옵션 정리
        for(let i = 0; optionList.length > i; i++) {
          posOptionList.push({
            productOptionGroupId: Number(posOptionGrpId),
            productStatus: 1,
            optionName: String(optionList[i].name),
            optionCost: Number(optionList[i].cost),
            exposureSequence: Number(optionList[i].visibleIndex),
            exposureStatus: 1
          })
        }
        // 옵션그룹 매핑
        axios.post(`${ORDER_PROXY_API}/product/v2/mapping/option-group/code`, {
          channelType: 2,
          data: [{
            posProductOptionGroupId: Number(posOptionGrpId),
            orderProductOptionGroupId: String(optionGrpId)
          }]
        }).then(() => {
          // 포스 옵션 등록
          axios.post(`${POS_API}/product/v2/option`, {
            modifierId: Number(posShopId),
            modifierType: 1,
            channelType: 2,
            productId: 0,
            mappingStatus: 0,
            productOptionItemList: posOptionList
          }).then((response) => {
            let addPosOptionList = response.data.productOptionIdList
            let list = []

            for(let j = 0; addPosOptionList.length> j; j++) {
              list.push({
                posProductOptionId: Number(addPosOptionList[j]),
                orderProductOptionId: String(addOptionList[j])
              })
            }
            // 옵션 매핑
            axios.post(`${ORDER_PROXY_API}/product/v2/mapping/option-code`, {
              channelType: 2,
              data: list
            }).then(() => {
              window.location.href = `/v2/optionList?shopSelect=${ shopId }`
            }).catch((e) => {
              console.log("옵션 매핑을 실패했습니다.");
              console.log(e);
            })
          }).catch((e) => {
            console.log("포스 옵션 등록을 실패했습니다.");
            console.log(e);
          })
        }).catch((e) => {
          console.log("옵션그룹 매핑을 실패했습니다.");
          console.log(e);
        })
      }).catch((e) => {
        console.log("포스 옵션그룹 등록을 실패했습니다.");
        console.log(e);
      })
    }).catch((e) => {
      console.log("옵션그룹 등록을 실패했습니다.");
      console.log(e);
    })
  }).catch((e) => {
    console.log("일치하는 상점이 없습니다.");
    console.log(e);
  })

}

// 옵션 그룹 수정
export function modifyOptionGrp(shopId, optionGrp, data) {
  let posShopId;
  let posOptionGrpId;

  // 포스 상점Id 구하기
  axios.get(`${ORDER_PROXY_API}/shop/v2/pos/shop-code?channelType=2&shopId=${shopId}`).then((response) => {
    posShopId = response.data.shopId;

    // 포스 옵션그룹Id 구하기
    axios.get(`${ORDER_PROXY_API}/product/v2/pos/option-group/code?channelType=2&productOptionGroupId=${optionGrp}`).then((response) => {
      posOptionGrpId = response.data.productOptionGroupId;

      // 주문 옵션그룹 수정
      axios.post(`${ORDER_API}/menu/v2/option/group`, {
        shopId: shopId,
        setOptionGroupList: [{
          optionGroupId: optionGrp,
          name: data.name,
          requiredChoice: data.requiredChoice,
          maxChoiceCount: data.maxChoiceCount
        }]
      }).then(() => {
        // 포스 옵션그룹 수정
        axios.put((`${POS_API}/product/v2/option-group`), {
          modifierId: posShopId,
          modifierType: 1,
          productOptionGroupId: posOptionGrpId,
          optionGroupName: data.name
        }).then(() => {
          if(data.addOptionList.length > 0) {
            newOption(shopId, posShopId, optionGrp, posOptionGrpId, data);
          } else if(data.setOptionList.length > 0 || data.removeOptionIdList.length > 0) {
            modifyOption(shopId, posShopId, optionGrp, posOptionGrpId, data);
          } else {
            window.location.reload();
          }
        }).catch((e) => {
          console.log(e);
          console.log("포스 옵션그룹 수정 실패했습니다.");
        })
      }).catch((e) => {
        console.log(e);
        console.log("주문 옵션그룹 수정 실패했습니다.");
      })
    }).catch((e) => {
      console.log(e);
      console.log("일치하는 옵션그룹이 없습니다.");
    })
  }).catch((e) => {
    console.log(e);
    console.log("일치하는 상점이 없습니다.");
  })
}

// 옵션 그룹 상태 변경
export const optionGrpStatusChange = async (shopId, optionGrpId, status) => {
  axios.put(`${BACK_OFFICE_API}/menu/optgrp/${optionGrpId}`, {
    id: optionGrpId,
    exposSta: Number(!status)
  }).then(() => {
    sessionStorage.setItem("targetId", `menuListBox${optionGrpId}`);
    window.location.reload();
  });
}


// 옵션 그룹 삭제
export const deleteOptionGrp = async (shopId, data) => {
  let posShopId = await shopMapping(shopId);

  axios.post(`${ORDER_API}/menu/v2/option/group`, {
    shopId: shopId,
    removeOptionGroupIdList: data
  }).then(() => {
    data.forEach(async (value) => {
      let posOptionGrpId = await optionGrpMapping(value);
      await axios.delete(`${POS_API}/product/v2/option-group`, {
        params: {
          modifierId: posShopId,
          modifierType: 1,
          itemIdList: posOptionGrpId
        }
      })
    })

    window.location.reload();
  })
}

// 옵션 등록 & 매핑
export function newOption(shopId, posShopId, grpId, posGrpId, data) {
  let optionIdList;
  let posOptionList = [];
  let addOption = data.addOptionList;
  let setOption = data.setOptionList;
  let removeOption = data.removeOptionIdList;

  // 주문 옵션 등록
  axios.post(`${ORDER_API}/menu/v2/option`, {
    shopId: shopId,
    optionGroupId: grpId,
    addOptionList: addOption
  }).then((response) => {
    optionIdList = response.data.addOptionIdList;

    // 포스 옵션 등록
    for(let i = 0; addOption.length > i; i++) {
      posOptionList.push({
        productOptionGroupId: posGrpId,
        productStatus: 1,
        optionName: addOption[i].name,
        optionCost: addOption[i].cost,
        exposureSequence: addOption[i].visibleIndex,
        exposureStatus: 1
      })
    }

    axios.post(`${POS_API}/product/v2/option`, {
      modifierId: posShopId,
      modifierType: 1,
      channelType: 2,
      productId: 0,
      mappingStatus: 0,
      productOptionItemList: posOptionList
    }).then((response) => {
      let addPosOptionList = response.data.productOptionIdList
      let list = []

      for(let j = 0; addPosOptionList.length> j; j++) {
        list.push({
          posProductOptionId: Number(addPosOptionList[j]),
          orderProductOptionId: String(optionIdList[j])
        })
      }
      // 옵션 매핑
      axios.post(`${ORDER_PROXY_API}/product/v2/mapping/option-code`, {
        channelType: 2,
        data: list
      }).then(() => {
        console.log("옵션 매핑 성공했습니다.");

        if(setOption.length > 0) {
          modifyOption(shopId, posShopId, grpId, posGrpId, data);
        } else if(removeOption.length > 0) {
          deleteOption(shopId, posShopId, grpId, posGrpId, data);
        }else {
          window.location.reload();
        }
      }).catch((e) => {
        console.log("옵션 매핑 실패했습니다.");
        console.log(e);
      })
    }).catch((e) => {
      console.log("포스 옵션 등록 실패했습니다.");
      console.log(e);
    })
  }).catch((e) => {
    console.log("주문 옵션 등록 실패했습니다.");
    console.log(e);
  })
}

// 옵션 수정
export function modifyOption(shopId, posShopId, grpId, posGrpId, data) {
  let setOption = data.setOptionList;
  let removeOption = data.removeOptionIdList;
  let uuidMake = Common.uuidMake()
  let uuid = `CW-${ posShopId }${ uuidMake }`;

  // 주문 채널 옵션 수정
  axios.post(`${ORDER_API}/menu/v2/option`, {
    shopId: shopId,
    optionGroupId: grpId,
    setOptionList: setOption
  }).then(() => {
    setOption.forEach(async (value) => {
      let posOptionId = await optionMapping(value.optionId);

      await axios.put(`${POS_API}/product/v2/option`, {
        uuid: uuid,
        modifierId: posShopId,
        modifierType: 1,
        productOptionId: posOptionId,
        optionName: value.name,
        optionCost: value.cost
      });
    });

    if(removeOption.length > 0) {
      deleteOption(shopId, posShopId, grpId, posGrpId, data);
    }else {
      window.location.reload();
    }
  })
}

// 옵션 삭제
export function deleteOption(shopId, posShopId, grpId, posGrpId, data) {
  let removeOption = data.removeOptionIdList;

  // 주문 채널 옵션 삭제
  axios.post(`${ORDER_API}/menu/v2/option`, {
    shopId: shopId,
    optionGroupId: grpId,
    removeOptionIdList: removeOption
  }).then(() => {
    removeOption.forEach(async (value) => {
      let posOptionId = await optionMapping(value.optionId);

      await axios.delete(`${POS_API}/product/v2/option`, {
        params: {
          modifierId: posShopId,
          modifierType: 1,
          itemIdList: posOptionId
        }
      });
    });

    window.location.reload();
  })
}

// 옵션 상태 변경
export function optionStatusChange(shopId, id, grpId, status) {
  let posShopId;
  let posOptionId;
  let statusText = "판매";
  if(status === 3) {
    statusText = "품절";
  } else if(status === 2) {
    statusText = "판매 중지";
  }

  axios.get(`${ORDER_PROXY_API}/shop/v2/pos/shop-code?channelType=2&shopId=${shopId}`).then((response) => {
    posShopId = response.data.shopId;

    axios.get(`${ORDER_PROXY_API}/product/v2/pos/option-code?channelType=2&productOptionId=${id}`).then((response) => {
      posOptionId = response.data.productOptionId;
      let uuidMake = Common.uuidMake()
      let uuid = `CW-${ posShopId }${ uuidMake }`


      axios.post(`${ORDER_API}/menu/v2/option`, {
        shopId: shopId,
        optionGroupId: grpId,
        setOptionList: [{
          optionId: id,
          status: status
        }]
      }).then(() => {
        axios.put(`${POS_API}/product/v2/option`, {
          uuid: uuid,
          modifierId: posShopId,
          modifierType: 1,
          productOptionId: posOptionId,
          productStatus: status
        }).then(() => {
          document.getElementById(`menuSelect${id}`).classList.remove("active");
          document.querySelector(`#menuSelect${id} .menuSelectText`).innerText = statusText;
          if(status === 1) {
            document.querySelector(`#menuSelect${id} .menuSelectText`).classList.remove("red");
          } else {
            document.querySelector(`#menuSelect${id} .menuSelectText`).classList.add("red");
          }
        })
      })
    })
  }).catch(() => {
    alert("일치하는 상점이 없습니다.");
  })
}

export const optionStatusChangeApi = async (shopId, grpId, optionId, status, list) => {
  const posShopId = await shopMapping(shopId);
  const uuid = getUuidMake(posShopId);

  if(list.length > 0) {
    list.map(async (value) => {
      const posOptionId = await optionMapping(value.id);
      await orderOptionStatusChangeApi(shopId, grpId, value.id, value.status, value.selected);
      await posOptionStatusChangeApi(posShopId, posOptionId, value.status, uuid);
    });
  }

  const menuSelect = document.getElementById(`menuSelect${optionId}`);
  const menuSelectText = menuSelect.querySelector(".menuSelectText")

  menuSelect.classList.remove("active");
  menuSelectText.innerText = menuStatusFormat(status);

  if(status === 1) {
    menuSelectText.classList.remove("red");
  } else {
    menuSelectText.classList.add("red");
  }
}

// 주문 채널 옵션 상태 변경
export const orderOptionStatusChangeApi = async (shopId, grpId, optionId, status, isSelected) => {
  await axios.post(`${ORDER_API}/menu/v2/option`, {
    shopId: shopId,
    optionGroupId: grpId,
    setOptionList: [{
      optionId: optionId,
      status: status,
      isSelected: isSelected
    }]
  });
}
// 포스 채널 옵션 상태 변경
export const posOptionStatusChangeApi = async (shopId, optionId, status, uuid) => {
  await axios.put(`${POS_API}/product/v2/option`, {
    uuid: uuid,
    modifierId: shopId,
    modifierType: 1,
    productOptionId: optionId,
    productStatus: status
  });
}

// 옵션 그룹 순서 변경
export const changeOptionGrpList = async (shopId, data) => {
  let posShopId = await shopMapping(shopId);

  axios.post(`${ORDER_API}/menu/v2/option/group`, {
    shopId: shopId,
    setOptionGroupList: data
  }).then(() => {
    data.forEach(async (value) => {
      let posOptionGrpId = await optionGrpMapping(value.optionGroupId);
      await axios.put(`${POS_API}/product/v2/option-group`, {
        modifierId: posShopId,
        modifierType: 1,
        productOptionGroupId: posOptionGrpId,
        exposureSequence: value.visibleIndex
      });
    });

    window.location.reload();
  });
}

// 옵션 순서 변경
export const changeOptionList = async (shopId, grpId, data) => {
  let posShopId = await shopMapping(shopId);
  let uuidMake = Common.uuidMake()
  let uuid = `CW-${ posShopId }${ uuidMake }`;

  axios.post(`${ORDER_API}/menu/v2/option`, {
    shopId: shopId,
    optionGroupId: grpId,
    setOptionList: data
  }).then(() => {
    data.forEach(async (value) => {
      let posOptionId = await optionMapping(value.optionId);
      await axios.put(`${POS_API}/product/v2/option`, {
        uuid: uuid,
        modifierId: posShopId,
        modifierType: 1,
        productOptionId: posOptionId,
        exposureSequence: value.visibleIndex
      });
    });

    window.location.reload();
  })
}

